import { ApiResource } from '../../api-resource';
import { Endpoint } from '../../api.decorators';
import { Field } from '../../../util/components/resource/resource-fields/resource-fields';
import { Staff } from '../../staff/staff.model';
import { Skillz } from '../skillz.model';

@Endpoint('staff-skill', 'StaffSkill')
export class StaffSkill extends ApiResource<StaffSkill> {
  @Field({ type: () => Skillz, label: $localize`Skill` })
  skill!: Skillz;

  @Field({ type: () => Staff, label: $localize`Staff` })
  staff!: Staff;

  @Field({ label: $localize`Approved` })
  approved!: boolean | null;
}

export enum SkillzApprovalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
}

export function getApprovalBoolean(
  status: SkillzApprovalStatus,
): boolean | null {
  switch (status) {
    case SkillzApprovalStatus.Approved:
      return true;
    case SkillzApprovalStatus.Rejected:
      return false;
    default:
      return null;
  }
}

export function getApprovalBooleanByKey(
  key: 'Approved' | 'Rejected' | 'Pending',
) {
  if (key === 'Approved') {
    return true;
  } else if (key === 'Rejected') {
    return false;
  } else {
    return null;
  }
}

export function getApprovalStatus(approved: boolean | null): {
  key: string;
  value: SkillzApprovalStatus;
} {
  if (approved === true) {
    return { key: 'Approved', value: SkillzApprovalStatus.Approved };
  } else if (approved === false) {
    return { key: 'Rejected', value: SkillzApprovalStatus.Rejected };
  } else {
    return { key: 'Pending', value: SkillzApprovalStatus.Pending };
  }
}
